export interface NumberRange {
  min: number
  max: number
}

export interface TargetRange extends NumberRange {
  target: number
}
